export const TYPE = {
    ADD_TASK: "ADD_TASK",
    REMOVE_TASK: "REMOVE_TASK",
    CLEAR_ALL: "CLEAR_ALL",
    CHANGE_STATUS:"CHANGE_STATUS",
    REMOVE_ALL_COMPLETED_TASKS:"REMOVE_ALL_COMPLETED_TASKS",
};


